import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Android, IOS } from "../../../PlatformContainer";
var ruStore = 'https://apps.rustore.ru/app/ru.beeline.services';

/** Временное решение для добавления RuStore к старым лендам без изменения контента
 * для отключения кнопки RuStore в компоненте передать пустой ключ ruStore: ''
 * */
export var formatStoreButtons = function formatStoreButtons(appButtons) {
  if (Object.keys(appButtons).includes('ruStore')) return appButtons;
  return _objectSpread(_objectSpread({}, appButtons), {}, {
    ruStore: ruStore
  });
};
export var STORE_TYPE = {
  ios: 'appStore',
  android: 'googlePlay',
  huawei: 'appGallery',
  ruStore: 'ruStore'
};
export var PLATFORM_TYPE = {
  ios: IOS,
  android: Android,
  huawei: Android,
  ruStore: Android
};